import { render, staticRenderFns } from "./SeletorPonto.vue?vue&type=template&id=77f6fe47&scoped=true&"
import script from "./SeletorPonto.vue?vue&type=script&lang=js&"
export * from "./SeletorPonto.vue?vue&type=script&lang=js&"
import style0 from "./SeletorPonto.vue?vue&type=style&index=0&id=77f6fe47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f6fe47",
  null
  
)

export default component.exports